
 

 

 

 
class PublicNewsCriteria 
{
    
        NewsTypeId: string | null;
    
        EffectiveDateForm: Date | null;
    
        EffectiveDateTo: Date | null;
    
}
 
export default PublicNewsCriteria;
 




